import { BaseApi } from '@/main/baseApi';
import { DMS_MODULE, NAME,SERVICE_JOB_SPLIT_BILLING, SPLIT_BILLING } from './constants';

class Provider extends BaseApi {
    getSplitDetails(itemId: number | null, orderId: number | null) {
        return this.fetch(`/${DMS_MODULE}/SplitBilling/GetSplitTooltip`, { itemId, orderId });
    }
    fetchInvoiceStatusOfServiceJobParty(serviceOrderId: number, serviceJobId: number, itemId: number, itemType: string, discountLimitPercent: number) {
  		    return this.fetch(`/${DMS_MODULE}/${SERVICE_JOB_SPLIT_BILLING}/FetchInvoiceStatusOfServiceJobParty`, { serviceOrderId, serviceJobId, itemId, itemType, discountLimitPercent });
    }
    validateServiceJobWhileExternalLoInsertion(serviceJobId: number, serviceOrderId: number, lineLevelDiscountLimitPercent: number | null, rrpUnitPrice: number, quantity: number) {
        return this.fetch(`/${DMS_MODULE}/${SERVICE_JOB_SPLIT_BILLING}/ValidateServiceJobWhileExternalLoInsertion`, { serviceJobId, serviceOrderId, lineLevelDiscountLimitPercent, rrpUnitPrice, quantity });
    }
    isPartOrLabourInvoiced(orderId: number, itemId: number, itemType: string) {
		    return this.fetch(`/${DMS_MODULE}/${SPLIT_BILLING}/IsPartOrLabourInvoiced`, { orderId, itemId, itemType});
    }
    isWarrantyOrGoodwillExistInServiceJobSplit(serviceOrderId:number, serviceJobId: number){
		    return this.fetch(`/${DMS_MODULE}/${SERVICE_JOB_SPLIT_BILLING}/IsWarrantyOrGoodWillSplitExistsInServiceJob`,{serviceOrderId, serviceJobId});
    }
    //TODO: Change to ext lo
    markExtLaborsAsComplte(laborIds: number[]) {
		    return this.post(`/${DMS_MODULE}/${NAME}/MarkExtLaborsAsComplte`, laborIds);
    }

    revertLabors(laborIds: number[]) {
      return this.post(`/${DMS_MODULE}/${NAME}/RevertExtLabors`, laborIds);
    }
    DeleteExternLabor(laborId: number) {
      return this.fetch(`/${DMS_MODULE}/${NAME}/DeleteExternLabor`, { laborId});
    }
  
	
}
export const apiProvider = new Provider(DMS_MODULE, NAME);
